import {
    fetchActions,
    IFetchStoreState,
    initialBaseState,
    initialFetchState,
    IUpdateStoreState,
    updateActions,
} from "./base-reducers";
import { IBrand, IBrandDetailed, IDataFlow, IRetailer, ISuggestion } from "containers/management/management-types";
import { handleActions } from "redux-actions";
import { UTILITIES } from "constants/action-types";
import { combineReducers } from "redux";

export interface IFlowState {
    dataflow: IDataFlow;
    coreFields: ISuggestion[];
    retailers: IRetailer[];
}

export type IFlowStoreState = IFetchStoreState<IFlowState> & IUpdateStoreState<IFlowState>;

export interface IDataFlowState {
    brandDetailed: IFetchStoreState<IBrandDetailed>;
    brands: IFetchStoreState<IBrand[]>;
    flow: IFlowStoreState;
    brandFlow: IFlowStoreState;
}

export const dataflow = combineReducers<IDataFlowState>({
    brandDetailed: handleActions<IFetchStoreState<IBrandDetailed>>(
        {
            ...fetchActions(UTILITIES.DATAFLOW_MANAGEMENT.BRAND_DETAILED.FETCH),
        } as any,
        initialFetchState,
    ),
    brands: handleActions<IFetchStoreState<IBrand[]>>(
        {
            ...fetchActions(UTILITIES.DATAFLOW_MANAGEMENT.BRANDS.FETCH),
        } as any,
        initialFetchState,
    ),
    flow: handleActions<IFlowStoreState>(
        {
            ...fetchActions(UTILITIES.DATAFLOW_MANAGEMENT.FLOW.FETCH),
            ...updateActions(UTILITIES.DATAFLOW_MANAGEMENT.FLOW),
        } as any,
        {
            ...initialBaseState,
            payload: { dataflow: null, coreFields: null, retailers: null },
        },
    ),
    brandFlow: handleActions<IFlowStoreState>(
        {
            ...fetchActions(UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW.FETCH),
            ...updateActions(UTILITIES.DATAFLOW_MANAGEMENT.BRAND_FLOW),
        } as any,
        {
            ...initialBaseState,
            payload: { dataflow: null, coreFields: null, retailers: null },
        },
    ),
});
